import React from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';
import Alert from 'react-bootstrap/Alert';
import Spinner from "react-bootstrap/Spinner";


import Header from './Header';
import Footer from './Footer';
import NewsBoard from './NewsBoard';


import 'bootstrap/dist/css/bootstrap.css';
import '../Estilos/Estilo.scss';

export default class Home extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			carousel: [],
			loading: true
		};
	}

	render() {
		const windowWidth = window.innerWidth;
   		const isDesktop = windowWidth > 600;
		return (
			<div className="homepage">
				<Header />
				
				<div className="content-home">
					<div className="carousel" >
						<Carousel>
							{this.state.loading ? <Spinner/> : this.state.carousel.map(({title, description, image, url})=>{
								return (
									<Carousel.Item key={title}>
										<a href={url} target="_blank" rel="noopener noreferrer">
											<img className="image" src={process.env.PUBLIC_URL+image}  alt={title}/>
											{isDesktop ? 
											<Carousel.Caption className='texto'>
												<Alert.Heading>{title}</Alert.Heading>
												<p className='descrip'>{description}</p>
											</Carousel.Caption> :
											<h2 className='descrip'>{title}</h2>}
										
										</a>
									</Carousel.Item>
								);
							})}
						</Carousel>				
					</div>
					
					<div className="featured-links">
						<Container>
								<Col xs={4} md={2}>
							
									<a href="/projects" >	
										<img src="assets/img/icons/projects.png" className="featured-link-icon" alt="Enlace a proyectos"/>
									</a>
								<h4>PROJECTS</h4>
								</Col>
								<Col xs={4} md={2}>
									<a href="/publications" >
										<img src="assets/img/icons/publications.png" className="featured-link-icon" alt="Enlace a publicaciones"/>
									</a>
									<h4>PUBLICATIONS</h4>
								</Col>
								<Col xs={4} md={2}>
									<a href='/technology-transfer'>
										<img src="assets/img/icons/innovation.png"  className="featured-link-icon" alt="Enlace a innovación"/>
									</a>
									<h4>INNOVATION</h4>
								</Col >
								{/*<Col>
									<a href='http://gryslab.etsist.upm.es'>
										<img src="assets/img/icons/livinglab.png" height="80" className="featured-link-icon" alt="Enlace al living lab"/>
									</a>
									<h4>LIVING LAB</h4>
								</Col>*/}
								<Col xs={4} md={2}>
								<a href='./sdg'>
									<img src="assets/img/icons/sdg.png" className="featured-link-icon" alt="Enlace a los ods"/>
								</a>
									<h4>SDG</h4>
								</Col>
							
						</Container>
					</div>
				</div>	  
				<div className="tablon">
					{isDesktop ? <NewsBoard total='6'/> : <NewsBoard total='3'/>}
				</div>
				<Footer/>
			</div>	
		)
	}
	
	componentDidMount(){
		window.scrollTo(0,0);
		fetch(process.env.PUBLIC_URL+"/assets/json/carousel.json").then(res=>res.json()).then(carousel=>this.setState({carousel, loading: false}))
	}

}


